exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".error.error-5 .error-title {\n  font-size: 7rem !important;\n}\n\n@media (min-width: 768px) {\n  .error.error-5 .error-title {\n    font-size: 14rem !important;\n  }\n}", ""]);

